<template>
  <div v-if="ranks !== null && Object.values(ranks.Phases).length > 0">
    <div class="title mb-3">{{ $t('pairRanks.title') }}</div>
    <b-container class="filter-section"
                 v-show="availablePhases.length > 1 || availableSessions.length > 1 || availableRanksets.length > 1">
      <b-row class="text-center">
        <b-col class="filter-label">{{ $t('filters.phase') }}</b-col>
        <b-col class="filter-label">{{ $t('filters.session') }}</b-col>
        <b-col class="filter-label">{{ $t('pairRanks.groups') }}</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col>
          <combo-or-label v-model="phase" :options="availablePhases"></combo-or-label>
        </b-col>
        <b-col>
          <combo-or-label v-model="session" :options="availableSessions"></combo-or-label>
        </b-col>
        <b-col>
          <combo-or-label v-model="rankSet" :options="availableRanksets"></combo-or-label>
        </b-col>
      </b-row>
    </b-container>


    <div v-if="simultaneousType === 2" class="mt-5 mb-3 text-center">
      <div class="rankTitle">{{ $t('pairRanks.nationalTitle') }}</div>
      <div class="rankAlert">{{ $t('pairRanks.nationalDisclaimer') }}</div>
    </div>


    <b-tabs class="rank">
      <b-tab v-for="(rank, rankIndex) in ranksToBeShown" :key="rankIndex"
             :title="rank.RankType === 0 ? $t('rankTabs.session') : $t('rankTabs.cumulative')">
        <template v-for="(rankRow, rowIndex) in rank.Rank">
          <b-table :fields="fieldsToBeShown" :items="rankRow" class="figbHeader" :key="rankIndex * 10000 + rowIndex">
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(FullName)="data">
              <span v-html="data.value"></span>
            </template>
          </b-table>
        </template>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ComboOrLabel from "@/components/lib/ComboOrLabel";
import individualContest from "../mixins/individualContest";

export default {
  name: 'Ranks',
  components: {ComboOrLabel},
  mixins: [individualContest],
  data() {
    return {
      phase: 1,
      session: 1,
      rankSet: 1
    }
  },
  computed: {
    ...mapGetters({
      globalDeals: 'deals/played',
      ranks: 'ranks/pairRanks',
      simultaneousType: 'tournament/simultaneousType'
    }),
    availablePhases() {
      return Object.keys(this.ranks?.Phases ?? {})
          .map(n => parseInt(n)).sort((a, b) => a - b);
    },
    availableSessions() {
      return Object.keys(
          this.ranks?.Phases[this.phase]?.Sessions ?? {}
      )
          .map(n => parseInt(n))
          .sort((a, b) => a - b);
    },
    availableRanksets() {
      return Object.keys(
          this.ranks
              ?.Phases[this.phase]
              ?.Sessions[this.session]
              ?.Ranksets ?? {}
      )
          .map(rkset => {
        return {
          value: rkset,
          text: this.globalDeals
              ?.Phases[this.phase]
              ?.Sessions[this.session]
              ?.Ranksets[rkset]
              ?.GroupedSectors.join('-') ?? this.$t('pairRanks.unique')
        }
      }).sort((a, b) => a.value - b.value);
    },
    ranksToBeShown() {
      const that = this;
      let ret = this.ranks
          ?.Phases[this.phase]
          ?.Sessions[this.session]
          ?.Ranksets[this.rankSet]
          ?.Ranks ?? null
      if (ret === null) {
        return []
      }


      if (this.session === 1 && that.phase === 1 && ret.length > 1) {
        //In case of first session, remove "session" rank, useless...
        ret = ret.filter(rnk => rnk.RankType === 1);
      }

      if (ret === undefined) {
        return [];
      }

      ret.forEach(rnk => {
        rnk.Rank.forEach(rn => {
          const found = rn.find(row => row.PairId === that.playerRankId)
          if (found !== undefined) {
            found._rowVariant = "warning";
          }
        });
      });
      return ret;
    },
    fieldsToBeShown() {
      return [
        {
          key: 'index',
          label: ''
        }, {
          key: 'FullName',
          label: this.$t('scoreViewer.pairName'),
          formatter: val => val.replace(" - ", "<br>")
        },
        {
          key: 'MP',
          label: 'MP'
        },
        {
          key: 'Percentage',
          label: this.$t('scoreViewer.percentage')
        },
        {
          key: 'PlayedBoards',
          label: this.$t('scoreViewer.board')
        }
      ];
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.phase = Math.max(...this.availablePhases);
        this.$nextTick(() => {
          this.session = Math.max(...this.availableSessions);
        });
    });
  }
};
</script>

<style scoped>
.header {
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
}

.rankTitle {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e3a5f;
}

.rankAlert {
  font-size: 0.9rem;
  color: #dc2626;
  font-weight: 500;
}

>>> .nav-link {
  color: #64748b;
  font-weight: 500;
}

.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e3a5f;
  letter-spacing: -0.01em;
}

>>> .rank .nav-link {
  background-color: #f8fafc;
  color: #64748b;
  border-top-right-radius: 0.5rem !important;
  border-top-left-radius: 0.5rem !important;
}

>>> .active {
  color: #1e3a5f !important;
  font-weight: 600 !important;
}

>>> .figbHeader thead {
  color: #1e3a5f !important;
  background-color: #eef2f7 !important;
}
</style>
